<template>
  <article>
    <input
      class="form-control v-hidden"
      type="password"
      id="otp"
      v-on="NOS_INSTANCE.listeners()"
      npkencrypt="on"
      data-keypad-type="number"
      data-keypad-theme="mobile"
      data-keypad-extend-ui="motp"
      data-keypad-next="__hide__"
      maxlength="6"
    />
    <input type="hidden" :value="getIncaOpen" />
  </article>
</template>

<script>
// import NOSController from "@/components/page/pluginFree/NOSController";
import { mapFields } from "vuex-map-fields";

export default {
  name: "OtpInput",
  components: {},
  props: {
    NOS_INSTANCE_REFERANCE: {
      required: false, //임시로 false, 필수로 받아야 함
      default: () => undefined,
    },
  },
  data() {
    return {
      opened: false,
      otp: "",
      json: {},
      NOS_INSTANCE: null,
    };
  },
  created() {
    this.NOS_INSTANCE = this.NOS_INSTANCE_REFERANCE;
    this.$store._mutations["common/supplCertn/mut002supplCertn"][0](this.NOS_INSTANCE_REFERANCE);
  },
  mounted() {},
  computed: {
    ...mapFields("common/supplCertn", ["isOpenSupplCertn"]),
    getIncaOpen() {
      this.$log.info(this.isOpenSupplCertn);
      if (this.isOpenSupplCertn) {
        document.getElementById("otp").focus();
        // this.NOS_INSTANCE.listeners();
      }
      return this.isOpenSupplCertn;
    },
  },
  methods: {
    confirm() {
      this.json = this.NOS_INSTANCE.toJSON();
      this.$emit("confirm");
    },
    open() {
      this.openedData = true;
    },
    reset() {
      this.otp = "";
      this.json = {};
    },
    getData() {
      return this.$v.$invalid || this.json;
    },
  },
};
</script>